// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_AtualizarConfigInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payments/accounts/atualizar_config/{id}
 *
 * Updates account configuration settings (notifications, webhook URLs, etc.)
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_AtualizarConfigInput {
config?: unknown[]
}

registerContract('SubaccountsFranchises_AtualizarConfigInput', {
  config: { type: 'array',   required: false },
})
